"use client";
import { useHero } from "@/hooks/usePublicData";
import { getImageWithFallback } from "@/lib/default-image";
import { useLocale } from "next-intl";
import ExploreProperties from "./ExploreProperties";
import Hero from "./Hero";
import ListPropertyCTA from "./ListPropertyCTA";
import Testimonials from "./Testimonials";
import WhyDiriyah from "./WhyDiriyah";

// Material Symbol helper
export function Icon({
  name,
  className = "",
  fill = false,
}: {
  name: string;
  className?: string;
  fill?: boolean;
}) {
  return (
    <span
      className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}
    >
      {name}
    </span>
  );
}

export default function Home() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const t = (ar: string, en: string) => (isAr ? ar : en);

  const { data: hero } = useHero();

  const heroImg = getImageWithFallback(hero?.image ?? null, "banner");
  const heroTitle = hero?.title
    ? isAr
      ? hero.title.ar
      : hero.title.en
    : t("اعثر على الإقامة المثالية", "Find your perfect stay");
  const heroSubtitle = hero?.subtitle
    ? isAr
      ? hero.subtitle.ar
      : hero.subtitle.en
    : t(
        "إكتشف أرقى الشقق في أكثر المناطق تميزاً بالسعودية، حيث تلتقي الأصالة بالفخامة العالمية.",
        "Discover the finest apartments in Saudi Arabia's most distinctive areas.",
      );

  return (
    <div className="najdi text-ink-900 overflow-x-hidden bg-background">
      <Hero
        isAr={isAr}
        heroImg={heroImg}
        heroTitle={heroTitle}
        heroSubtitle={heroSubtitle}
        slides={hero?.slides ?? []}
      />

      {/* ── 2. Explore Properties (real data) ── */}

      <ExploreProperties locale={locale} isAr={isAr} />
      <WhyDiriyah isAr={isAr} />
      <Testimonials isAr={isAr} />
      <ListPropertyCTA locale={locale} isAr={isAr} image={hero?.image} />
    </div>
  );
}
